import { Paper } from '@mui/material';
import FormationsManagement from '../components/Tables/FormationsManagement';

interface FormationsProps {

}

function Formations(FormationsProps: FormationsProps) {

	return (
		<>
			<Paper elevation={0} sx={{padding: 2}}>
				<FormationsManagement/>
			</Paper>
		</>
	);
}

export default Formations;